export var FormTab;

(function (FormTab) {
  FormTab["SectionDetail"] = "section-detail";
  FormTab["GeneralInformation"] = "general-information";
  FormTab["Assignment"] = "assignment";
})(FormTab || (FormTab = {}));